import { useEffect, useState } from 'react';
import { Form, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useAuth } from 'react-oidc-context';
import UserTable from './UserTable';
import DetailModal from './DetailModal';
import UploadBulk from './UploadBulk';
import InviteModal from './InviteModal';
import SessionExpiredModal from '../../utils/SessionExpiredModal';
import { Button, IconButton, ThemeProvider, createTheme, styled } from '@mui/material';
import ConfirmationModal from '../../utils/ConfirmationModal';

import GroupAddIcon from '@mui/icons-material/GroupAdd';

import SearchIcon from '@mui/icons-material/Search';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});

const TextButton = styled(Button)(({ theme }) => ({
  color: 'white',
  textTransform: 'none',
  padding: '0.5vw 0.75vw',
}));

export default (props) => {
  const [
    userData,
    setUserData,
  ] = useState([]);

  const [
    detailModalShown,
    setDetailModalShown,
  ] = useState(false);

  const [
    inviteModalShown,
    setInviteModalShown,
  ] = useState(false);

  const [
    uploadModalShow,
    setUploadModalShow,
  ] = useState(false);

  const [
    currentUserId,
    setCurrentUserId,
  ] = useState('');

  const [
    isLoading,
    setIsLoading,
  ] = useState(true);

  const [
    searchQuery,
    setSearchQuery,
  ] = useState('');

  const [
    sessionExpired,
    setSessionExpired,
  ] = useState(false);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredUserData = userData.filter(user =>
    user.email.toLowerCase().includes(searchQuery.toLowerCase())
    || user.firstName.toLowerCase().includes(searchQuery.toLowerCase())
    || user.lastName.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const auth = useAuth();

  const [
    showConfirm,
    setShowConfirm,
  ] = useState(false);
  const [
    selectedUserId,
    setSelectedUserId,
  ] = useState(null);

  function openModalHandler(userId){
      setDetailModalShown(true)
      setCurrentUserId(userId)
  }


  function closeDetailModalHandler() {
    setDetailModalShown(false);
    setCurrentUserId('');
    setSelectedUserId(null);
  }

  function closeInviteModalHandler() {
    setInviteModalShown(false);
  }

  function closeUploadModal() {
    setUploadModalShow(false);
  }

  const handleConfirmDelete = async () => {
    if (!selectedUserId) return;

    try {
      const res = await fetch(`${window.origin}/api/users/${selectedUserId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      });

      if (!res.ok) throw new Error('Delete failed');

      setUserData(prev => prev.filter(u => u.id !== selectedUserId));
      setShowConfirm(false);
      setSelectedUserId(null);
    } catch (e) {
      console.error(e);
      setShowConfirm(false);
    }
  };

  useEffect(() => {
    if (auth.user?.profile.accountant.ssid) {
      console.log('execute');
      fetch(`${window.origin}/api/users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
      }).then((response) => {
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        return response.json();
      }).then((data) => {
        setUserData(data.filter(item => item.email !== auth.user?.profile.email));
        setIsLoading(false);
      }).catch((error) => {
        console.error('Failed to fetch workers:', error);
      });
    }
  }, [auth.user?.profile.accountant.ssid]);

  return (
    <div style={{ margin: '0.5vw 2.5vw' }}>
      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Manage team members and access control
      </p>
      <SessionExpiredModal show={sessionExpired} />
      <>
        <div style={{ marginBottom: '1vw', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <div style={{ backgroundColor: 'rgb(254, 254, 255, 0.7)', borderRadius: '0.8vw', padding: '0.5vw', paddingLeft: '1vw', width: '15vw', color: 'rgb(0, 15, 30, 0.7)' }}>
            <ThemeProvider theme={darkTheme}>

              <SearchIcon style={{ fontSize: '1vw' }} />
            </ThemeProvider>

            <Form.Control
              id="client-search-bar"
              style={{
                display: 'inline', backgroundColor: 'rgba(255,255,255,0)', padding: 0, paddingLeft: '0.5vw',
                border: '1px solid rgb(254, 254, 255, 0)', borderRadius: '6px', fontSize: '0.9vw', maxWidth: '80%', marginLeft: '0', fontWeight: '200',
              }}
              className="shadow-none"
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={handleSearchChange}
            />
          </div>

          <div style={{ flex: 1, textAlign: 'right', paddingLeft: '1vw', paddingRight: '0' }}>
            <OverlayTrigger
              key="top-submit"
              placement="top"
              overlay={(
                <Tooltip id="tooltip-submit">
                  Create Request
                </Tooltip>
              )}
            >
              <TextButton id="create-new-workpaper" variant="text" style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', cursor: 'pointer', padding: '0.8vw', minWidth: 0, borderRadius: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.8)', marginLeft: '1vw' }} onClick={() => setInviteModalShown(true)}>
                <i className="fa-solid fa-plus" style={{ fontSize: '0.9vw', width: '0.95vw', height: '0.95vw' }}></i>
              </TextButton>

            </OverlayTrigger>
          </div>
        </div>

        <div style={{ margin: '0 0', padding: 0, fontSize: '1.6rem', lineHeight: '2.8rem', borderRadius: '20px' }}>
          <div style={{ width: '100%', textAlign: 'left' }}>
            <UserTable userData={filteredUserData} openModalHandler={openModalHandler} isLoading={isLoading} />
          </div>
        </div>

      </>
      <ConfirmationModal show={showConfirm} onClose={() => { setShowConfirm(false); setSelectedUserId(null); }} onConfirm={handleConfirmDelete} title="Delete User" message="Are you sure you want to delete this user?" />
      <DetailModal show={detailModalShown} onClose={closeDetailModalHandler} userId={currentUserId} />
      <InviteModal show={inviteModalShown} onClose={closeInviteModalHandler} />
      <UploadBulk uploadModalShow={uploadModalShow} closeUploadModal={closeUploadModal} />
    </div>
  );
};
